module.exports = __webpack_public_path__ + "img/metabolize.185ac6af.png";